module.exports = __webpack_public_path__ + "static/media/ask_ai.45351f7a.svg";